import { formatDayRange } from "../../shared/dateRange";
/**
 * This function builds the query for Deal ID options. The query
 * reads `vw_deals.deal_id` on `explore_inventory`. The view file
 * behind this join is named `pdt_bidstream_deal`. The join name in
 * this explore is `vw_deals`. The query filters this field to one
 * line item, through `vw_deals.inst_id`. See dealIds.ts in
 * models/looker/modules/bidstream for why this query targets the
 * PDT and not `explore_bidstream`.
 *
 * `dateRange`, when given, adds a `vw_deals.validation_date` filter
 * (day-granular). Omitted, the query is unbounded - see dealIds.ts for
 * the 14-day history cap.
 */
export const buildDealIdOptionsQuery = (lineItemId, dateRange) => ({
    view: "explore_inventory",
    model: "client_analytics",
    fields: ["vw_deals.deal_id"],
    sorts: ["vw_deals.deal_id asc"],
    limit: "-1",
    column_limit: "500",
    filters: {
        "vw_deals.inst_id": lineItemId,
        ...(dateRange && { "vw_deals.validation_date": formatDayRange(dateRange) })
    }
});
//# sourceMappingURL=query.js.map